import { FormLogo } from '@/components/FormLogo';
import { Link } from '@bancobarigui/barihaus';
import { PublicRouteContainer } from '@/components/PublicRouteContainer';
import { useServiceCheck } from '@/contexts/service-status';
import { Alert } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import { LoginForm } from './LoginForm';

import { useLogin } from './useLogin';

export default function Login() {
  const { onSubmit, forgotPassword, loading } = useLogin();
  const { anyOffline, isChecking } = useServiceCheck(['auth', 'user']);

  const isSystemUnavailable = anyOffline && !isChecking;

  return (
    <PublicRouteContainer>
      <FormLogo />

      {isSystemUnavailable ? (
        <div className="w-full text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100 mb-4">
            <ExclamationCircleOutlined className="text-3xl text-red-500" />
          </div>
          <Alert
            type="error"
            message="Sistema Indisponível"
            description="O sistema está temporariamente indisponível. Por favor, tente novamente em alguns instantes."
            showIcon={false}
            className="!rounded-xl !border-red-200 !bg-red-50"
          />
          <p className="text-slate-500 text-sm mt-4">
            Nossos servidores estão passando por manutenção ou enfrentando problemas técnicos.
          </p>
        </div>
      ) : (
        <div className="w-full">
          <div className="text-center mb-6">
            <h1 className="text-2xl font-bold text-slate-800 mb-2">Bem-vindo de volta</h1>
            <p className="text-slate-500">Entre com suas credenciais para acessar o sistema</p>
          </div>

          <LoginForm onSubmit={onSubmit} loading={loading || isChecking} />

          <div className="text-center" style={{ marginTop: 24 }}>
            <Link
              onClick={forgotPassword}
              className="!font-medium !transition-colors"
              style={{ color: '#101010' }}
            >
              Esqueceu sua senha?
            </Link>
          </div>
        </div>
      )}
    </PublicRouteContainer>
  );
}
